import {
    Box,
    CircularProgress,
    Card,
    CardContent,
    Typography,
    Chip,
    Stack,
    Divider,
} from "@mui/material";
import { ZIELMUSKEL_LABELS } from "./constants";

function UebungenListe({ uebungen, listLoading }) {
    return (
        <Card>
            <CardContent>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                    Deine Übungen ({uebungen.length})
                </Typography>

                {listLoading ? (
                    <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
                        <CircularProgress size={32} />
                    </Box>
                ) : uebungen.length === 0 ? (
                    <Typography color="text.secondary">
                        Noch keine eigenen Übungen angelegt.
                    </Typography>
                ) : (
                    <Stack spacing={2} divider={<Divider />}>
                        {uebungen.map((uebung) => (
                            <Box key={uebung.id}>
                                <Typography variant="subtitle1" fontWeight={600}>
                                    {uebung.uebung_name}
                                </Typography>
                                {uebung.uebung_beschreibung && (
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        sx={{ mt: 0.5 }}
                                    >
                                        {uebung.uebung_beschreibung}
                                    </Typography>
                                )}
                                <Stack direction="row" spacing={1} sx={{ mt: 1 }} flexWrap="wrap" useFlexGap>
                                    <Chip
                                        label={uebung.kategorie}
                                        size="small"
                                        color="primary"
                                        variant="outlined"
                                    />
                                    {uebung.zielmuskel && (
                                        <Chip
                                            label={
                                                ZIELMUSKEL_LABELS[uebung.zielmuskel] ||
                                                uebung.zielmuskel
                                            }
                                            size="small"
                                            variant="outlined"
                                        />
                                    )}
                                </Stack>
                            </Box>
                        ))}
                    </Stack>
                )}
            </CardContent>
        </Card>
    );
}

export default UebungenListe;
